export default __webpack_public_path__ + "static/media/Philosopher Armbands.78b9d485.jpg";